import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { useNavigate } from "react-router";
import { useQueryClient } from '@tanstack/react-query';

import { clearApiCache } from "../helpers/clearApiCache";
import { Transitions } from "../theme";
import { useAuth } from "../hooks";

import { UserContextActions } from "./redux/userContext.reducer";

const LogoutButton = styled.span`
  padding: ${props => (props.$padding ? props.$padding : "15px")};
  background-color: transparent;
  border: none;
  transition: ${Transitions.custom};
  cursor: pointer;
  z-index: 1;
  &:hover {
    opacity: 0.7;
  }
`;

const Logout = ({ children, logout, padding }) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const queryClient = useQueryClient();

  const onLogOutClick = async () => {
    await logout();
    clearApiCache();
    queryClient.clear();
    signOut();
    navigate("/");
  }

  return (
    <LogoutButton $padding={padding} onClick={onLogOutClick}>{children}</LogoutButton>
  );
};

const mapStateToProps = ownProps => ({ ...ownProps });

const mapDispatchToProps = dispatch => ({ logout: () => dispatch(UserContextActions.setLoggedOut()) });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Logout);
